(() => {

  'use strict';

  angular
    .module('specsguardApp')
    .factory('sgExpansionPanelFactory', sgExpansionPanelFactory);

  function sgExpansionPanelFactory () {

    const expansionCtrl: any = {};

    // Close the panel
    expansionCtrl.closeAll = () => {
      const openPanel = document.body.querySelector('.sg-expansion-panel--open');

      if (openPanel) {
        openPanel.classList.remove('sg-expansion-panel--open');
      }

    };

    return expansionCtrl;
  }

})();
